export const batchOptions = Array.from({ length: 12 }, (_, i) => {
  return `${2012 + i} - ${2012 + i + 1}`
}).reverse()

export const tenantName = {
  // anurag: 'aupulse',
  giet: 'giet',
  campx: 'campx_dev',
}
